module.exports = __webpack_public_path__ + "static/media/sidebar-2782b7d79a2d7ed6abb68509d66c73272jpg";